import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  Communication,
  EditRecurringCommunicationStatusPayload,
  SchedulePayload,
  SaveCommunicationResult,
  EmailRecipientFilter,
  CommDashboardKpi,
  GenericResponse,
  ListItem,
  QueryItem
} from '../../models/communication.model';
import {
  CommunicationTableItem,
  CommunicationTableMetadata,
  Paged,
} from '@k12/models';
import { ScheduledRecipient } from '../../models/recipient.model';
import { IUserRecordCommunicationsService } from '@k12/admin-services';

@Injectable({
  providedIn: 'root'
})
export class CommunicationCenterDashboardService implements IUserRecordCommunicationsService {

  private readonly http = inject(HttpClient);

  getDashboardCommunicationGrid(payload: CommunicationTableMetadata): Observable<Paged<CommunicationTableItem>> {
    return this.http.post(`${environment.adminApiUrl}/commcenter/dashboardCommunicationGrid`, payload) as Observable<Paged<CommunicationTableItem>>;
  }

  getCommunication(id: string): Observable<Communication> {
    return this.http.get<Communication>(`${environment.adminApiUrl}/commcenter/communication/${id}`);
  }

  deleteCommunication(id: string): Observable<GenericResponse> {
    return this.http.delete<GenericResponse>(`${environment.adminApiUrl}/commcenter/communication/delete/${id}`);
  }

  partnerTypes(): Observable<ListItem[]> {
    return this.http.get<ListItem[]>(`${environment.adminApiUrl}/valueList/partnerTypes`);
  }

  communicationTypes(): Observable<ListItem[]> {
    return this.http.get<ListItem[]>(`${environment.adminApiUrl}/valueList/communicationTypes`);
  }

  queryList(): Observable<ListItem[]> {
    return this.http.get<ListItem[]>(`${environment.adminApiUrl}/valueList/communicationQueriesList`);
  }

  templateList(templateTypeId: number): Observable<ListItem[]> {
    return this.http.get<ListItem[]>(
      `${environment.adminApiUrl}/valueList/templateList?templateTypeId=${templateTypeId}`
    );
  }

  dashboardKPI(): Observable<CommDashboardKpi[]> {
    return this.http.get<CommDashboardKpi[]>(`${environment.adminApiUrl}/commcenter/dashboardKpi`);
  }

  getEmailRecipients(payload: EmailRecipientFilter): Observable<Paged<ScheduledRecipient>> {
    return this.http.post<Paged<ScheduledRecipient>>(`${environment.adminApiUrl}/commcenter/emailRecipients?subscription-key=${environment.subscriptionKey}`, payload);
  }

  scheduleCommunication(payload: SchedulePayload): Observable<SaveCommunicationResult> {
    return this.http.post<SaveCommunicationResult>(`${environment.adminApiUrl}/commcenter/communication`, payload);
  }

  updateRecurringCommunicationStatus(payload: EditRecurringCommunicationStatusPayload): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(
      `${environment.adminApiUrl}/commcenter/communication/EditRecurringStatus`,
      payload
    );
  }

  getSavedQueries(): Observable<QueryItem[]> {
    return this.http.get<QueryItem[]>(`${environment.adminApiUrl}/commcenter/savedQueries`);
  }
}
